export const styles = () => ({
  container: {
    flexBasis: '26%',
    borderRight: '1px solid rgba(53, 64, 82, 0.1)',
    overflow: 'hidden',
    minWidth: 270,
  },
})
